import customAxios from "../../customAxios";
// import {ADMIN_ALL_SERVICE} from "../../routes";

type Props = {
  page?: string | number;
  limit?: string | number;
};

const getAllService = async (props: Props) => {
  const ADMIN_ALL_SERVICE = "";

  var thisUrl = ADMIN_ALL_SERVICE + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_ALL_SERVICE: error });
  }
};

export default getAllService;
